export function fetchUserMask(apiUrl, accessToken, userId) {
    return fetch(`${apiUrl}/v1/userinfo/${userId}/mask`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function removeUserMask(apiUrl, accessToken, userId) {
    return fetch(`${apiUrl}/v1/userinfo/${userId}/mask`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function updateUserMask(apiUrl, accessToken, userId, mask) {
    return fetch(`${apiUrl}/v1/userinfo/${userId}/mask`, {
        method: 'PUT',
        body: JSON.stringify({ mask: mask }),
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }
    });
}
export function fetchAssociatedDealers(apiUrl, accessToken, userId) {
    return fetch(`${apiUrl}/v1/userinfo/${userId}/associated-dealers`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function fetchTmAssociatedDealers(apiUrl, accessToken) {
    return fetch(`${apiUrl}/v1/userinfo/associated-dealers/tm`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
